import intlTelInput from 'intl-tel-input';

document.querySelectorAll('.phonable').forEach(input => {
    let iti = intlTelInput(input, {
        nationalMode: true,
        initialCountry: input.dataset.country || 'US',
        utilsScript: '/vendor/phones/js/utils.js',
        // geoIpLookup: function(callback) {
        //     $.get('https://ipinfo.io', function() {}, "jsonp").always(function(resp) {
        //         let countryCode = (resp && resp.country) ? resp.country : "us";
        //         callback(countryCode);
        //     });
        // }, //not free
        preferredCountries: ['US', 'AU', 'NZ']
    });

    let handleChange = function() {
        document.querySelector(input.dataset.intl).value = iti.getNumber();
    };

    input.addEventListener('change', handleChange);
    input.addEventListener('keyup', handleChange);
});